import React from 'react'
// import { useIntl } from 'gatsby-plugin-react-intl';

import { LayoutBase } from './layout-base'
import { graphql, useStaticQuery } from 'gatsby'
import { mapNavigationMenuProps } from '../../data-mappers/organims/navigation-menu.mapper'
import { mapFooterProps } from '../../data-mappers/organims/footer.mapper'

type LayoutFrProps = {
  children: React.ReactElement[]
}

export const LayoutFr = ({ children }: LayoutFrProps) => {
  const data = useStaticQuery(graphql`
    query LayoutFrQuery {
      cms {
        navigation(locale: "fr") {
          ...navigationMenuFragment
        }
        footer(locale: "fr") {
          ...footerFragment
        }
      }
    }
  `)

  const {
    cms: { navigation, footer },
  } = data

  return (
    <>
      <LayoutBase menu={mapNavigationMenuProps(navigation)} footer={mapFooterProps(footer)}>
        {children}
      </LayoutBase>
    </>
  )
}
